import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TwitterIcon from '@mui/icons-material/X';
import Image from "next/image";
import {SvgIcon} from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import RedditIcon from "@mui/icons-material/Reddit";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" mt={1}>
            {'Copyright © '}
            <Link href="https://Dax.Best/">Dax.Best&nbsp;</Link>
            {new Date().getFullYear()}
        </Typography>
    );
}

export default function Footer() {
    const [tokenPrice, setTokenPrice] = useState(null);

    useEffect(() => {
        const fetchTokenPrice = async () => {
            try {
                const response = await fetch('https://api.geckoterminal.com/api/v2/simple/networks/flare/token_price/0xde373ae127a11e756a9d1cc7743816928b239283', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch token price');
                }

                const data = await response.json();
                setTokenPrice(data.data?.attributes?.token_prices?.['0xde373ae127a11e756a9d1cc7743816928b239283']);
            } catch (error) {
                console.error('Error fetching token price:', error);
            }
        };

        fetchTokenPrice();
    }, []);

    const TikTokIcon = (props: any) => (
        <SvgIcon {...props}>
            <path d="M22.539 6.192a5.482 5.482 0 0 1-3.313-1.076 5.489 5.489 0 0 1-2.028-2.719 5.508 5.508 0 0 1-.262-1.7H14.14v14.72a4.842 4.842 0 1 1-2.514-4.254V7.647a8.077 8.077 0 0 0-1.147-.081 8.254 8.254 0 1 0 4.485 15.155 8.247 8.247 0 0 0 3.944-7.169V8.896a9.87 9.87 0 0 0 3.631 1.178v-3.882z" />
        </SvgIcon>
    );

    const DiscordIcon = (props: any) => (
        <SvgIcon viewBox="0 0 50 50">
            <path d="M 41.625 10.769531 C 37.644531 7.566406 31.347656 7.023438 31.078125 7.003906 C 30.660156 6.96875 30.261719 7.203125 30.089844 7.589844 C 30.074219 7.613281 29.9375 7.929688 29.785156 8.421875 C 32.417969 8.867188 35.652344 9.761719 38.578125 11.578125 C 39.046875 11.867188 39.191406 12.484375 38.902344 12.953125 C 38.710938 13.261719 38.386719 13.429688 38.050781 13.429688 C 37.871094 13.429688 37.6875 13.378906 37.523438 13.277344 C 32.492188 10.15625 26.210938 10 25 10 C 23.789063 10 17.503906 10.15625 12.476563 13.277344 C 12.007813 13.570313 11.390625 13.425781 11.101563 12.957031 C 10.808594 12.484375 10.953125 11.871094 11.421875 11.578125 C 14.347656 9.765625 17.582031 8.867188 20.214844 8.425781 C 20.0625 7.929688 19.925781 7.617188 19.914063 7.589844 C 19.738281 7.203125 19.34375 6.960938 18.921875 7.003906 C 18.652344 7.023438 12.355469 7.566406 8.320313 10.8125 C 6.214844 12.761719 2 24.152344 2 34 C 2 34.175781 2.046875 34.34375 2.132813 34.496094 C 5.039063 39.605469 12.972656 40.941406 14.78125 41 C 14.789063 41 14.800781 41 14.8125 41 C 15.132813 41 15.433594 40.847656 15.621094 40.589844 L 17.449219 38.074219 C 12.515625 36.800781 9.996094 34.636719 9.851563 34.507813 C 9.4375 34.144531 9.398438 33.511719 9.765625 33.097656 C 10.128906 32.683594 10.761719 32.644531 11.175781 33.007813 C 11.234375 33.0625 15.875 37 25 37 C 34.140625 37 38.78125 33.046875 38.828125 33.007813 C 39.242188 32.648438 39.871094 32.683594 40.238281 33.101563 C 40.601563 33.515625 40.5625 34.144531 40.148438 34.507813 C 40.003906 34.636719 37.484375 36.800781 32.550781 38.074219 L 34.378906 40.589844 C 34.566406 40.847656 34.867188 41 35.1875 41 C 35.199219 41 35.210938 41 35.21875 41 C 37.027344 40.941406 44.960938 39.605469 47.867188 34.496094 C 47.953125 34.34375 48 34.175781 48 34 C 48 24.152344 43.785156 12.761719 41.625 10.769531 Z M 18.5 30 C 16.566406 30 15 28.210938 15 26 C 15 23.789063 16.566406 22 18.5 22 C 20.433594 22 22 23.789063 22 26 C 22 28.210938 20.433594 30 18.5 30 Z M 31.5 30 C 29.566406 30 28 28.210938 28 26 C 28 23.789063 29.566406 22 31.5 22 C 33.433594 22 35 23.789063 35 26 C 35 28.210938 33.433594 30 31.5 30 Z"></path>
        </SvgIcon>
    );
    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 4, sm: 8 },
                py: { xs: 8, sm: 10 },
                textAlign: { sm: 'center', md: 'left' },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                        minWidth: { xs: '100%', sm: '60%' },
                    }}
                >
                    <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
                        <Box sx={{ ml: '0px' }}>
                            <Image
                                src="/DaXLogo.png"
                                alt="DaX Logo"
                                width={128}
                                height={51}
                            />
                        </Box>
                        {tokenPrice ? (
                            <Button
                                variant="contained"
                                size="large"
                                color="warning"
                                startIcon={<Image
                                    src="/geckoterminal_icon.svg"
                                    alt="Geckoterminal Logo"
                                    width={20}
                                    height={20}
                                />}
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.geckoterminal.com/de/flare/pools/0xb2868e9fef2b5efb4aa4853a539a6ba26177b8c3"
                            >
                                The DAX Price is ${tokenPrice}
                            </Button>
                        ) : (
                            <Button variant="contained" size="large" color="error">The DAX Price is not available.</Button>
                        )}
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: { xs: 'none', sm: 'flex' },
                        flexDirection: 'column',
                        gap: 1,
                    }}
                >
                    <Typography variant="body2" fontWeight={600}>
                        Page
                    </Typography>
                    <Link color="text.secondary" href="/#roadmap">
                        Roadmap
                    </Link>
                    <Link color="text.secondary" href="/#community">
                        Community
                    </Link>
                </Box>
                <Box
                    sx={{
                        display: { xs: 'none', sm: 'flex' },
                        flexDirection: 'column',
                        gap: 1,
                    }}
                >
                    <Typography variant="body2" fontWeight={600}>
                        Whitepapers
                    </Typography>
                    <Link color="text.secondary" href="/whitepapers/project">
                        Projekt
                    </Link>
                    <Link color="text.secondary" href="/whitepapers/token">
                        Token
                    </Link>
                    <Link color="text.secondary" href="/whitepapers/lottery">
                        Lottery
                    </Link>
                    <Link color="text.secondary" href="/whitepapers/nfts">
                        NFTs
                    </Link>
                </Box>
                <Box
                    sx={{
                        display: { xs: 'none', sm: 'flex' },
                        flexDirection: 'column',
                        gap: 1,
                    }}
                >
                    <Typography variant="body2" fontWeight={600}>
                        Company
                    </Typography>
                    <Link color="text.secondary" href="/aboutus">
                        About us
                    </Link>

                    <Link color="text.secondary" href="/grafik-repository">
                        Grafik Repository
                    </Link>

                </Box>


                <Box
                    sx={{
                        display: { xs: 'none', sm: 'flex' },
                        flexDirection: 'column',
                        gap: 1,
                    }}
                >
                    <Typography variant="body2" fontWeight={600}>
                        Legal
                    </Typography>
                    <Link color="text.secondary" href="/terms">
                        Terms
                    </Link>
                    <Link color="text.secondary" href="/privacy">
                        Privacy
                    </Link>
                    <Link color="text.secondary" href="/contact">
                        Contact
                    </Link>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    pt: { xs: 4, sm: 8 },
                    width: '100%',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <div>
                    <Copyright />
                </div>
                <Stack
                    direction="row"
                    justifyContent="left"
                    spacing={1}
                    useFlexGap
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    <IconButton
                        color="inherit"
                        href="https://discord.gg/WSKVVRGWqn"
                        aria-label="Discord"
                        target="_blank"
                        sx={{ alignSelf: 'center' }}
                    >
                        <DiscordIcon />
                    </IconButton>

                    <IconButton
                        color="inherit"
                        href={'https://t.me/dax_best'}
                        target="_blank"
                        aria-label="Telegram"
                        sx={{ alignSelf: 'center' }}
                    >
                        <TelegramIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        href="https://twitter.com/FlareDax"
                        target="_blank"
                        aria-label="X"
                        sx={{ alignSelf: 'center' }}
                    >
                        <TwitterIcon />
                    </IconButton>

                    <IconButton
                        color="inherit"
                        href="https://www.tiktok.com/@dax.best"
                        target="_blank"
                        aria-label="TikTok"
                        sx={{ alignSelf: 'center' }}
                    >
                        <TikTokIcon />
                    </IconButton>

                    <IconButton
                        color="inherit"
                        href="https://www.reddit.com/r/DaxBest/"
                        target="_blank"
                        aria-label="Reddit"
                        sx={{ alignSelf: 'center' }}
                    >
                        <RedditIcon />
                    </IconButton>


                    <IconButton
                        color="inherit"
                        href="https://chat.whatsapp.com/Fx4tJXqSmL1F66BegoEz1B"
                        target="_blank"
                        aria-label="WhatsApp"
                        sx={{ alignSelf: 'center' }}
                    >
                        <WhatsAppIcon />
                    </IconButton>



                </Stack>
            </Box>
        </Container>
    );
}